import { useState } from 'react';
import axios from 'axios';
import { LifeBuoy, Send, Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { Textarea } from './ui/textarea';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fase 2 Task 2.4 — Pulsante flottante "Richiedi Supporto Consulente" per il cliente autenticato.
 * Genera email a Agente + TopAgent + Admin + SuperAdmin + notifica in-app (badge campanella).
 */
export default function RichiediSupportoButton() {
  const { getAuthHeader } = useAuth();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  const handleSend = async () => {
    if (!message.trim()) { toast.error('Scrivi un messaggio prima di inviare'); return; }
    setSending(true);
    try {
      await axios.post(`${API}/client/support-request`, { message }, { headers: getAuthHeader() });
      toast.success('Richiesta inviata. Il tuo consulente ti risponderà a breve.');
      setMessage('');
      setOpen(false);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Invio non riuscito');
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        className="fixed bottom-5 right-5 z-40 rounded-full h-14 w-14 shadow-lg bg-emerald-600 hover:bg-emerald-700 gap-0"
        title="Richiedi Supporto"
        data-testid="btn-richiedi-supporto"
      >
        <LifeBuoy className="w-6 h-6" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="supporto-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <LifeBuoy className="w-5 h-5 text-emerald-600" /> Richiedi Supporto Consulente
            </DialogTitle>
            <DialogDescription>
              La tua richiesta verrà inoltrata al consulente di riferimento e all'ufficio MaCheNoleggio.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <p className="text-sm text-slate-600">
              Scrivi qui la tua richiesta. Verrà inviata al tuo consulente di riferimento
              e ai responsabili MaCheNoleggio.
            </p>
            <Textarea
              rows={5}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Es. Vorrei chiedere maggiori dettagli sul preventivo Alfa Romeo..."
              data-testid="supporto-textarea"
            />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} disabled={sending}>Annulla</Button>
            <Button className="gap-1 bg-emerald-600 hover:bg-emerald-700" onClick={handleSend} disabled={sending} data-testid="btn-invia-supporto">
              {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
              Invia richiesta
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
